import React, { memo } from "react";
import { styled } from "@mui/material/styles";
import AvatarField from "./AvatarField";

const Root = styled("div")(({ theme }) => ({
  display: "flex",
  flexWrap: "nowrap",
  alignItems: "center",
}));

const StyledAvatar = styled(AvatarField)(({ theme }) => ({
  marginRight: theme.spacing(1),
  marginTop: -theme.spacing(0.5),
  marginBottom: -theme.spacing(0.5),
}));

const FullNameField = ({ record, size, source, label }) => {
  return record ? (
    <Root>
      <StyledAvatar record={record} size={size} />
      {record[source]}
    </Root>
  ) : null;
};

FullNameField.defaultProps = {
  source: "name",
  label: "Name",
};

export default memo(FullNameField);
